import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import { injectIntl } from 'react-intl';

import { makeStyles, Container, Grid, Paper, CircularProgress } from '@material-ui/core';
import styles from './styles';
import { Field, Form, Formik } from 'formik';
import { SYSTEM_DOC_TYPES } from 'app/utils/constants';
import DocumentField from 'app/components/DocumentField';
import manualsEndpoint from 'app/api/services/manualsEndpoint';
import notification from 'app/config/notification';
const useStyles = makeStyles(styles);

function Manuals(props) {
  const classes = useStyles();
  const [uploading, setUpLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleChangeFile = async (docParam, row) => {
    //   return;
    if (docParam.id) {
      const payload = {
        idFile: docParam.id,
        tpDocumentoSistema: row.tpDocumentoSistema,
      };
      if (row.cdDocumentoSistema) {
        payload.cdDocumentoSistema = row.cdDocumentoSistema;
      }
      const response = await manualsEndpoint.save(payload);
      if (response.status === 200) {
        notification('Arquivo cadastrado com sucesso.', {
          toastId: 'successfully',
          type: 'success',
        });
      } else {
        notification('Erro ao cadastrar arquivo. Tente novamente.', {
          toastId: 'successfully',
          type: 'error',
        });
      }
      setUpLoading(false);
    }
  };

  const handleDeleteFile = idFile => {};

  const [rows, setRows] = useState(() => {
    return Object.keys(SYSTEM_DOC_TYPES).map(tpDocumentoSistema => {
      const temp = {
        tpDocumentoSistema,
        label: SYSTEM_DOC_TYPES[tpDocumentoSistema].label,
      };
      return temp;
    });
  });

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      const response = await manualsEndpoint.getAll();
      if (response.status === 200 && response.data) {
        const result = rows.map(row => {
          const temp = { ...row };
          temp.value = null;
          temp.idFile = null;
          const found = _.find(response.data, ['tpDocumentoSistema', row.tpDocumentoSistema]);
          if (found) {
            temp.cdDocumentoSistema = found.cdDocumentoSistema;
            temp.value = SYSTEM_DOC_TYPES[row.tpDocumentoSistema].label;
            temp.idFile = found.idFile;
          }
          return temp;
        });
        setRows(result);
        setLoading(false);
      }
    };
    init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <Grid container spacing={3} className={classes.documentsContainer}>
        <Grid item xs={12}>
          <div className={classes.centerProgress}>
            <CircularProgress size={12} />
          </div>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper elevation={0} variant="outlined" square className={classes.paper}>
              <Formik enableReinitialize={true} initialValues={{}} onSubmit={values => {}}>
                {props => {
                  return (
                    <Form className={classes.containerForm}>
                      {rows.map(row => {
                        return (
                          <Grid
                            container
                            key={`manual-${row.tpDocumentoSistema}`}
                            style={{
                              alignItems: 'center',
                              marginBottom: '10px',
                              paddingBottom: '10px',
                              borderBottom: '1px solid #ccc',
                            }}
                          >
                            <Grid item xs={6}>
                              {row.label}
                            </Grid>
                            <Grid item xs={6} style={{ textAlign: 'right' }}>
                              <Field
                                id={row.tpDocumentoSistema}
                                name={row.tpDocumentoSistema}
                                value={row.value}
                                required={true}
                                label={row.label}
                                disabled={false}
                                idGdoc={null}
                                idFile={row.idFile}
                                onChangeFile={docResult => {
                                  handleChangeFile(docResult, row);
                                }}
                                onDeleteFile={idFile => handleDeleteFile(idFile, row)}
                                uploading={uploading}
                                setUpLoading={setUpLoading}
                                onlyIcon={true}
                                component={DocumentField}
                              />
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Form>
                  );
                }}
              </Formik>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default injectIntl(Manuals);
